export default __webpack_public_path__ + "static/media/keel.0f9a0e68.png";